<script setup lang="ts">
	import { cn } from '@/helpers/cn'

	interface Props {
		class?: string
	}

	const props = defineProps<Props>()
</script>

<template>
	<th
		:class="
			cn(
				'p-4 text-left text-gray-600 font-semibold bg-gray-50 font-inter',
				props.class
			)
		"
	>
		<slot />
	</th>
</template>
